/* ABALO · cuenta atrás para bloques .abnotice__cd (evergreen, se reinicia por visitante) */
(function(){
  function initCountdowns(root){
    (root||document).querySelectorAll('.abnotice__cd').forEach(function(el){
      if(el.getAttribute('data-ab-init')==='1') return;
      el.setAttribute('data-ab-init','1');
      var mins=parseInt(el.getAttribute('data-min'),10)||30;
      var id=el.id||('abn-'+Math.random().toString(36).slice(2));
      var key='abn-end-'+id;
      var end;
      try{ end=parseInt(localStorage.getItem(key),10); }catch(e){ end=null; }
      if(!end||isNaN(end)||end<Date.now()){ end=Date.now()+mins*60000; try{localStorage.setItem(key,end);}catch(e){} }
      var H=el.querySelector('[data-h]'),M=el.querySelector('[data-m]'),S=el.querySelector('[data-s]');
      function p(n){return (n<10?'0':'')+n;}
      function tick(){
        var d=end-Date.now(); if(d<0){d=0;}
        if(H)H.textContent=p(Math.floor(d/3600000));
        if(M)M.textContent=p(Math.floor(d%3600000/60000));
        if(S)S.textContent=p(Math.floor(d%60000/1000));
      }
      tick(); setInterval(tick,1000);
    });
  }
  if(document.readyState!=='loading'){ initCountdowns(); }
  else{ document.addEventListener('DOMContentLoaded', function(){ initCountdowns(); }); }
  document.addEventListener('shopify:section:load', function(e){ initCountdowns(e.target); });
})();

/* ABALO · añadir a la cesta sin salir de la página + detalle sutil en el icono del carrito (toda la web) */
(function(){
  function cartLinks(){ return Array.prototype.slice.call(document.querySelectorAll('a[href$="/cart"]')); }
  function ensureDot(link){
    link.classList.add('abx-cart-rel');
    var d=link.querySelector('.abx-cart-dot');
    if(!d){ d=document.createElement('span'); d.className='abx-cart-dot'; d.setAttribute('aria-hidden','true'); link.appendChild(d); }
    return d;
  }
  function paint(count, pulse){
    cartLinks().forEach(function(link){
      var d=ensureDot(link);
      if(count>0){ d.classList.add('show'); if(pulse){ d.classList.remove('abx-pulse'); void d.offsetWidth; d.classList.add('abx-pulse'); } }
      else{ d.classList.remove('show'); }
    });
  }
  function setNativeCount(n){
    try{
      document.querySelectorAll('cart-count').forEach(function(el){ el.textContent=n; });
    }catch(_){}
  }
  function refresh(pulse){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(c){ var n=c.item_count||0; paint(n, pulse); setNativeCount(n); })
      .catch(function(){});
  }
  var toast, tmr;
  function ensureToast(){
    if(toast) return toast;
    toast=document.createElement('div'); toast.className='abx-toast'; toast.setAttribute('role','status');
    toast.innerHTML='<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M5 12l4 4L19 6"/></svg><span class="abx-toast-msg">Añadido a la cesta</span><a href="/cart" class="abx-toast-link">Ver cesta</a>';
    document.body.appendChild(toast);
    return toast;
  }
  function showToast(d){
    d=d||{};
    var t=ensureToast();
    t.querySelector('.abx-toast-msg').textContent=d.msg||'Añadido a la cesta · sigue comprando';
    var lk=t.querySelector('.abx-toast-link'); if(lk) lk.textContent=d.link||'Ver cesta';
    if(d.bg) t.style.background=d.bg;
    t.classList.add('show'); clearTimeout(tmr);
    tmr=setTimeout(function(){ t.classList.remove('show'); }, 2600);
  }
  document.addEventListener('abalo:added', function(e){
    refresh(true);
    var d=e.detail||{};
    if(d.toast!==false) showToast(d);
    try{ document.documentElement.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true})); }catch(_){}
  });
  function boot(){ refresh(false); }
  if(document.readyState!=='loading'){ boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
})();
